import React from "react";
import Image from "@jetshop/ui/Image";
import { cleanProps } from "../../../helpers";
import Typography from "../../ui/Typography";
import { theme } from "../../Theme";
import { css, cx } from "emotion";

const mbSm = css`
  margin-bottom: ${theme.spaces.sm};
`;

function ArticleHero(props) {
  const clean = cleanProps(props);
  return (
    <div>
      <Image
        src={clean.heroImage}
        alt={clean.heroAlt}
        aspect="4:1"
        cover
        className={cx(mbSm)}
      />
      <Typography variant="h1" mb={"0.25em"}>
        {clean.title}
      </Typography>
      <Typography variant="h2" styleVariant="h4" mb={"0.5em"}>
        {clean.ingress}
      </Typography>
    </div>
  );
}

export default ArticleHero;
